module.exports = __webpack_public_path__ + "files/74a2ddb74b3411ba92f22a99084fc2f8.png";